export const bulkMintTokenContract =
  "0x0C4DCc2dc216fF3Fe1A7A4F6c9B5D71cbA10AFC2";
  export const multisendTokenContract =
  "0x63C2464BC8b0B22e00Df459310b728414dF6BE4e";